import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var SimpleSearchComponent = function SimpleSearchComponent(componentClassName) {
  return function (_ref) {
    var className = _ref.className,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ["className", "children"]);

    return /*#__PURE__*/React.createElement("span", _extends({
      className: classNames("cloud-ui-search-".concat(componentClassName), className)
    }, props), children);
  };
};

export var SearchHeaderCount = SimpleSearchComponent('count');
export var SearchHeaderNotice = SimpleSearchComponent('notice');
export var SearchHeaderTitle = SimpleSearchComponent('title');
export var SearchHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchHeader, _React$Component);

  var _super = _createSuper(SearchHeader);

  function SearchHeader() {
    _classCallCheck(this, SearchHeader);

    return _super.apply(this, arguments);
  }

  _createClass(SearchHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          count = _this$props.count,
          notice = _this$props.notice,
          children = _this$props.children,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["title", "count", "notice", "children", "className"]);

      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames('cloud-ui-search-header', className)
      }, props), title && /*#__PURE__*/React.createElement(SearchHeaderTitle, null, title, count > 0 && /*#__PURE__*/React.createElement(SearchHeaderCount, null, " (", count, ")")), notice && /*#__PURE__*/React.createElement(SearchHeaderNotice, null, notice), children);
    }
  }]);

  return SearchHeader;
}(React.Component);

_defineProperty(SearchHeader, "propTypes", {
  className: PropTypes.string,
  count: PropTypes.number,
  notice: PropTypes.string,
  title: PropTypes.string
});

_defineProperty(SearchHeader, "Count", SearchHeaderCount);

_defineProperty(SearchHeader, "Notice", SearchHeaderNotice);

_defineProperty(SearchHeader, "Title", SearchHeaderTitle);

export default SearchHeader;